import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export default function SubmitFormDialog({dialogProps}) {
  const [open, setOpen] = React.useState(dialogProps.isOpen);
  const { fetchStatus, summary } = dialogProps;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

  useEffect(() => {

    if(dialogProps.isOpen == true) {
        setOpen(true);
        // handleClickOpen();

    }else {

        setOpen(false);
    }
  })

  const handleClose = () => {
    setOpen(false);
    window.location = '/';
  };

  const calcLoanDisbursement = (loanAmt, serviceFee) => {
    var disburseFee = (parseInt(serviceFee)/100) * parseInt(loanAmt);

    var disburseAmt = (parseInt(loanAmt) - disburseFee);
    return disburseAmt.toLocaleString();
  }

  const calcWeeklyRepayment = (loanAmt) => {
    var weeklyRepay = (parseInt(loanAmt) / 4);
    return weeklyRepay.toLocaleString();
  }

  const calcServiceFee = (loanAmt, serviceFee) => {
    var disburseFee = (parseInt(serviceFee)/100) * parseInt(loanAmt);
    return disburseFee.toLocaleString();
  }

  return (
    <div>
      {
        fetchStatus === 'success' ?
        <Dialog
          fullScreen={fullScreen}
          open={dialogProps.isOpen}
          onClose={dialogProps.handleClose === '' ? handleClose: dialogProps.handleClose}
          aria-labelledby="responsive-dialog-title"
          className="dialog-cover"
        >
          <DialogTitle id="responsive-dialog-title">{dialogProps.names}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <p dangerouslySetInnerHTML={{__html: dialogProps.msg}} />
              <div className="summary-container">
                <div className="summary-cover">
                  <div className="summary-header">
                    <p className="summary-p">SUMMARY</p>
                  </div>
                  <div className="summary-content">
                    <div className="summary-content-flex">
                      <div className="summary-content-flex-item"><p className="summary-first-item-p">Loan Amount:</p></div>
                      <div className="summary-content-flex-item"><p className="summary-last-item-p">{`N${parseInt(summary.loanAmount).toLocaleString()}`}</p></div>
                      <div className="summary-content-flex-item"><p className="summary-first-item-p">Service Fee (5%):</p></div>
                      <div className="summary-content-flex-item"><p className="summary-last-item-p">{`N${calcServiceFee(summary.loanAmount, summary.serviceFee)}`}</p></div>
                      <div className="summary-content-flex-item"><p className="summary-first-item-p">Duration:</p></div>
                      <div className="summary-content-flex-item"><p className="summary-last-item-p">{summary.loanDuration}</p></div>
                      <div className="summary-content-flex-item"><p className="summary-first-item-p">Amount To Receive:</p></div>
                      <div className="summary-content-flex-item"><p className="summary-last-item-p">{`N${calcLoanDisbursement(summary.loanAmount, summary.serviceFee)}`}</p></div>
                      <div className="summary-content-flex-item"><p className="summary-first-item-p">Weekly Repayment:</p></div>
                      <div className="summary-content-flex-item"><p className="summary-last-item-p">{`N${calcWeeklyRepayment(summary.loanAmount)}`}</p></div>
                      <div className="summary-content-flex-item"><p className="summary-first-item-p">Total Repayment:</p></div>
                      <div className="summary-content-flex-item"><p className="summary-last-item-p">{`N${parseInt(summary.loanAmount).toLocaleString()}`}</p></div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={dialogProps.handleClose} color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog> :
        <Dialog
          fullScreen={fullScreen}
          open={dialogProps.isOpen}
          onClose={dialogProps.handleClose === '' ? handleClose: dialogProps.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{dialogProps.names}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <p dangerouslySetInnerHTML={{__html: dialogProps.msg}} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={dialogProps.handleClose} color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      }
      
    </div>
  );
}
